export function formatTimestamp(dateStr) {
  if (!dateStr) return "";
  const dt = new Date(dateStr);
  const localeDate = dt.toLocaleString();
  const utcLocaleTime = dt.toLocaleTimeString({}, { timeZone: "UTC", hour12: false, timeZoneName: "short" });
  const utcSuffix = `(${utcLocaleTime})`;
  return `${localeDate} ${utcSuffix}`;
}
